import type { IconKey } from '@/lib/content/defaults/navigation'

import { LucideIcon } from './lucide-icon'

export function IconFromKey({ iconKey, className }: { iconKey: IconKey; className?: string }) {
  return <LucideIcon name={iconKey} className={className} />
}
